import config from '@/config';

export const resolveUrl = (region: string): string | undefined => {
  const env = ['prod', 'darklive'].includes(process.env.NODE_CONFIG_ENV || '')
    ? 'prod'
    : 'stage';
  return config?.fusion?.[region.toUpperCase()]?.[env];
};

export const createScript = (src: string): HTMLScriptElement => {
  const script = document.createElement('script');
  script.id = 'fusion-lib';
  script.src = src;
  script.async = true;
  return script;
};
